/**
 * A callback function that takes the app version `number` as an argument, or `undefined` if the app version cannot be determined.
 * @callback callbackFunction
 * @param {number | undefined} appVersion - The app version number.
 * @returns {unknown} The result of the callback function.
 */

/**
 * Check which app version is being used.
 * @param {callbackFunction} cb - A callback that handles the response, it takes the app version `number` as an argument,
 * or `undefined` if the app version cannot be determined.
 * @returns {unknown} Returns `unknown`.
 */

function checkAppVersion(cb) {
  if (
    navigator.userAgent.indexOf('An Post') !== -1 &&
    navigator.userAgent.indexOf('/v') !== -1
  ) {
    const appVersion = parseInt(
      navigator.userAgent.split('/v')[1].split(' ')[0].split('/')[0],
      10
    )
    return cb(appVersion)
  }
  return cb(undefined)
}

export default checkAppVersion
